import React from "react";
import { SubtitleProps } from "./props";

/**
 * Primary UI component for user interaction
 */
const Subtitle = ({ properties, style }: SubtitleProps): React.JSX.Element => {
  return <p className={"vcl-subtitle"} style={{ ...style }} {...properties} />;
};

export default Subtitle;
